
type NextPageErrorProps = {
  message?: string;
  title?: string;
  retryable?: boolean;
  action?: {
    label: string;
    path: string;
  }
};

export class NextPageError extends Error {
  constructor(props: NextPageErrorProps) {
    super(JSON.stringify(props));
    this.name = 'NextPageError';
  }

  static fromError(error: Error): NextPageErrorProps | undefined {
    if (error.name !== 'NextPageError') {
      return undefined;
    }

    return JSON.parse(error.message);
  }
}
